import Route from 'cio/routes/base';

export default class RecipientsRoute extends Route {
  crumb() {
    return {
      name: 'Recipients',
      path: this.routeName,
    };
  }

  setupController(controller, model) {
    super.setupController(...arguments);

    let hasRandomSubset = model.get('sendPercentage') !== 100;
    controller.set('expandRandomSubset', hasRandomSubset);
  }
}
